module.exports = __webpack_public_path__ + "img/lianghao.e6a2db62.png";